import { FileUploadStatus } from '../lib/input-file/InputFile.enums';

export default {
    checkoutDeliveryOption: {
        headerLabel: 'Opción de entrega',
        headerDescriptionLabel:
            '¿Debe SteelBuy entregar todos los artículos a una sola dirección o a varias direcciones?',
        singleAddressLabel: 'Dirección única',
        singleAddressDescriptionLabel: 'Su pedido se enviará a 1 dirección.',
        multipleAddressLabel: 'Múltiples direcciones',
        multipleAddressDescriptionLabel: 'Su pedido se enviará a múltiples direcciones.',
    },
    checkout: {
        delivery: {
            title: 'Entrega',
            haulierRequiredMessage: '¿Necesitamos reservar una franja de entrega para este artículo?',
            checkboxYes: 'Sí',
            checkboxNo: 'No',
            materialLocationLabel: 'Ubicación del material',
        },
        deliveryText: 'Tiempo de entrega estimado',
        payment: {
            optionCreditLabel: 'Crédito',
            optionCreditExplanation: 'Su pedido se enviará directamente.',
            optionUpfrontLabel: 'Pago por adelantado',
            optionUpfrontExplanation: 'Su pedido se enviará una vez recibamos su pago.',
        },
        shippingCostsLabel: 'Entrega',
        totalExclVat: 'Total (sin IVA)',
        total: 'Total',
        itemsTotalExclVat: 'Total de artículos (sin IVA)',
        itemsTotal: 'Total de artículos',
        totalInclVat: 'Total (con IVA)',
        vatLabel: '+ {{value}}% IVA',
        weight: 'Peso',
        theoreticalWeight: 'Peso teórico',
    },
    dropdown: {
        deselectAll: 'Deseleccionar todo',
        selectAll: 'Seleccionar todo',
        noOptions: 'Sin opciones',
        filterPlaceholder: 'Buscar...',
    },
    fileInput: {
        showMoreLabel: 'Mostrar más',
        showLessLabel: 'Mostrar menos',
        fileInputLabel: 'Seleccione archivos',
        filesUploaded: '{{uploadedCount}} de {{totalFiles}} cargados',
        filesizeKB: '{{size}}KB',
        filesizeMB: '{{size}}MB',
        sizeAndStatus: '{{size}} – {{status}}',
        fileUploadStatus: {
            [FileUploadStatus.Uploading]: 'Cargando',
            [FileUploadStatus.Error]: 'Error',
            [FileUploadStatus.Success]: 'Cargado',
        },
        browse: 'Navegar',
    },
    notification: {
        freightEstimate:
            'El precio entregado incluye una estimación del costo de flete; el flete final puede ajustarse una vez que se confirme el momento de recogida con el vendedor.',
        freightQuoteUnavailable:
            'Cotización de flete no disponible. Comuníquese con SteelBuy para solicitar una cotización.',
    },
};
